export default [
    {
        name: 'zombieArgueModel',
        type: 'fbxModel',
        path: 'models/Zombie/zombie_argue.fbx'
    },
    {
        name: 'zombieYellingModel',
        type: 'fbxModel',
        path: 'models/Zombie/zombie_yelling.fbx'
    },
    {
        name: 'zombieVictoryModel',
        type: 'fbxModel',
        path: 'models/Zombie/zombie_victory.fbx'
    },
    {
        name: 'zombieAgonyModel',
        type: 'fbxModel',
        path: 'models/Zombie/zombie_agony.fbx'
    },
    {
        name: 'zombieSaluteModel',
        type: 'fbxModel',
        path: 'models/Zombie/zombie_salute.fbx'
    },
    {
        name: 'actorStand',
        type: 'gltfModel',
        path: 'models/Zombie/Stand/scene.gltf'
    },
    {
        name: 'bridge',
        type: 'gltfModel',
        path: 'models/Bridge/scene.gltf'
    },
    {
        name: 'planet0',
        type: 'gltfModel',
        path: 'models/Planet/Planet0/scene.gltf'
    },
    {
        name: 'planet1',
        type: 'gltfModel',
        path: 'models/Planet/Planet1/scene.gltf'
    },
    {
        name: 'planet2',
        type: 'gltfModel',
        path: 'models/Planet/Planet2/scene.gltf'
    },
    {
        name: 'planet3',
        type: 'gltfModel',
        path: 'models/Planet/Planet3/scene.gltf'
    },
    {
        name: 'planet4',
        type: 'gltfModel',
        path: 'models/Planet/Planet4/scene.gltf'
    },
    {
        name: 'planet5',
        type: 'gltfModel',
        path: 'models/Planet/Planet5/scene.gltf'
    },
    {
        name: 'guard1',
        type: 'fbxModel',
        path: 'models/Guard/source/Helmet.fbx'
    },
    {
        name: 'nike',
        type: 'gltfModel',
        path: 'models/Scores/Nike/scene.gltf'
    },
    {
        name: 'textureRedNucleus',
        type: 'texture',
        path: 'textures/bg/nucleus/starred.webp'
    },
    {
        name: 'textureGreenNucleus',
        type: 'texture',
        path: 'textures/bg/nucleus/stargreen.jpg'
    },
    {
        name: 'texturePinkNucleus',
        type: 'texture',
        path: 'textures/bg/nucleus/starpink.webp'
    },
    {
        name: 'textureOrangeNucleus',
        type: 'texture',
        path: 'textures/bg/nucleus/starorange.jpg'
    },
    {
        name: 'textureYellowNucleus',
        type: 'texture',
        path: 'textures/bg/nucleus/staryellow.webp'
    },
    {
        name: 'texturePurpleNucleus',
        type: 'texture',
        path: 'textures/bg/nucleus/starpurple.jpg'
    },
    {
        name: 'mainNucleus',
        type: 'texture',
        path: 'textures/nucleus/main/T_skulls_17_Albedo.webp'
    },
    {
        name: 'mainNucleusMetalness',
        type: 'texture',
        path: 'textures/nucleus/main/T_skulls_17_Metalness.png'
    },
    {
        name: 'mainNucleusRoughness',
        type: 'texture',
        path: 'textures/nucleus/main/T_skulls_17_Roughness.png'
    },
    {
        name: 'mainNucleusNormal',
        type: 'texture',
        path: 'textures/nucleus/main/T_skulls_17_Normal.png'
    },
    {
        name: 'mainNucleusAoMap',
        type: 'texture',
        path: 'textures/nucleus/main/T_skulls_17_AO.png'
    },
    {
        name: 'greenNucleusInside',
        type: 'texture',
        path: 'textures/bg/nucleus/greenNucleusInside.jpg'
    },
    {
        name: 'greenNucleusInsidePositive',
        type: 'texture',
        path: 'textures/bg/nucleus/greenNucleusInsidePositive.jpg'
    },
    {
        name: 'redInsideNucleus',
        type: 'texture',
        path: 'textures/bg/nucleus/redInsideNucleus.jpg'
    },
    {
        name: 'redInsideNucleusPositive',
        type: 'texture',
        path: 'textures/bg/nucleus/redInsideNucleusPositive.jpg'
    },
    {
        name: 'purpleNucleusInside',
        type: 'texture',
        path: 'textures/bg/nucleus/purpleNucleusInside.jpg'
    },
    {
        name: 'purpleNucleusInsidePositive',
        type: 'texture',
        path: 'textures/bg/nucleus/purpleNucleusInsidePositive.jpg'
    },
    {
        name: 'pinkNucleusInside',
        type: 'texture',
        path: 'textures/bg/nucleus/pinkNucleusInside.jpg'
    },
    {
        name: 'pinkNucleusInsidePositive',
        type: 'texture',
        path: 'textures/bg/nucleus/pinkNucleusInsidePositive.jpg'
    },
    {
        name: 'yellowNucleusInside',
        type: 'texture',
        path: 'textures/bg/nucleus/yellowNucleusInside.jpg'
    },
    {
        name: 'yellowNucleusInsidePositive',
        type: 'texture',
        path: 'textures/bg/nucleus/yellowNucleusInsidePositive.jpg'
    },
    {
        name: 'orangeNucleusInside',
        type: 'texture',
        path: 'textures/bg/nucleus/orangeNucleusInside.jpg'
    },
    {
        name: 'orangeNucleusInsidePositive',
        type: 'texture',
        path: 'textures/bg/nucleus/orangeNucleusInsidePositive.jpg'
    },
    {
        name: 'textureMars',
        type: 'texture',
        path: 'textures/bg/textureMars.webp'
    },
    {
        name: 'textureJupiter',
        type: 'texture',
        path: 'textures/bg/textureJupiter.jpg'
    },
    {
        name: 'textureNeptune',
        type: 'texture',
        path: 'textures/bg/textureNeptune.jpg'
    },
    {
        name: 'textureDeath',
        type: 'texture',
        path: 'textures/bg/textureDeath.jpg'
    },
    {
        name: 'textureSun',
        type: 'texture',
        path: 'textures/bg/textureSun.jpg'
    },
    {
        name: 'textureIce',
        type: 'texture',
        path: 'textures/bg/textureIce.webp'
    },
    {
        name: 'textureMoon',
        type: 'texture',
        path: 'textures/bg/textureMoon.webp'
    },
    {
        name: 'textureRedRing',
        type: 'texture',
        path: 'textures/bg/redRing.jpg'
    },
    {
        name: 'alphaCage',
        type: 'texture',
        path: 'textures/alpha/cage.png'
    },
    {
        name: 'textureBlueRing',
        type: 'texture',
        path: 'textures/bg/blueRing.jpg'
    },
    {
        name: 'textureYellowRing',
        type: 'texture',
        path: 'textures/bg/yellowRing.jpg'
    },
    {
        name: 'textureOrangeRing',
        type: 'texture',
        path: 'textures/bg/orangeRing.jpg'
    },
    {
        name: 'textureGreenRing',
        type: 'texture',
        path: 'textures/bg/greenRing.jpg'
    },
    {
        name: 'aquaNavy',
        type: 'texture',
        path: 'textures/bg/aquaNavy.jpg'
    },
    {
        name: 'textureNavyRing',
        type: 'texture',
        path: 'textures/bg/navyRing.jpg'
    },
    {
        name: 'textureSilverRing',
        type: 'texture',
        path: 'textures/bg/silverRing.jpg'
    },
    {
        name: 'textureSilverDarkRing',
        type: 'texture',
        path: 'textures/bg/textureSilverDarkRing.jpg'
    },
    {
        name: 'textureBrownRing',
        type: 'texture',
        path: 'textures/bg/brownRing.jpg'
    },
    {
        name: 'textureDarkBrownRing',
        type: 'texture',
        path: 'textures/bg/darkBrownRing.jpg'
    },
    {
        name: 'baseRocket1',
        type: 'gltfModel',
        path: 'models/Capsule/Capsule7/scene.gltf'
    },
    {
        name: 'baseRocket2',
        type: 'gltfModel',
        path: 'models/Capsule/Capsule3/scene.gltf'
    },
    {
        name: 'baseRocket3',
        type: 'gltfModel',
        path: 'models/Capsule/Capsule1/scene.gltf'
    },
    {
        name: 'baseRocket4',
        type: 'gltfModel',
        path: 'models/Capsule/Capsule6/scene.gltf'
    },
    {
        name: 'baseRocket5',
        type: 'gltfModel',
        path: 'models/Capsule/Capsule2/scene.gltf'
    },
    {
        name: 'mainBackground',
        type: 'texture',
        path: 'textures/bg/mainBackground.jpg'
    },
    {
        name: 'background',
        type: 'texture',
        path: 'textures/bg/mainBackground.jpg'
    },
    {
        name: 'textureStar',
        type: 'texture',
        path: 'textures/stars/stars.png'
    },
    {
        name: 'textureAstroBlue',
        type: 'texture',
        path: 'textures/stars/astroBlue.png'
    },
    {
        name: 'textureAstroRed',
        type: 'texture',
        path: 'textures/stars/astroRed.png'
    },
    {
        name: 'textureAstroGold',
        type: 'texture',
        path: 'textures/stars/astroGold.png'
    },
    {
        name: 'textureAstroGreen',
        type: 'texture',
        path: 'textures/stars/astroGreen.png'
    },
    {
        name: 'textureAstroAlpha',
        type: 'texture',
        path: 'textures/stars/astroAlpha.png'
    },
    {
        name: 'textureStar1',
        type: 'texture',
        path: 'textures/stars/star1.png'
    },
    {
        name: 'textureStar2',
        type: 'texture',
        path: 'textures/stars/star2.png'
    },
    {
        name: 'textureStar3',
        type: 'texture',
        path: 'textures/stars/star3.png'
    },
    {
        name: 'corporationLogo',
        type: 'texture',
        path: 'textures/corporation.png'
    },
    {
        name: 'warsLogo',
        type: 'texture',
        path: 'textures/wars.png'
    },
    {
        name: 'chapterLogo',
        type: 'texture',
        path: 'textures/corpo-chapter-dev.png'
    },
    {
        name: 'hologramBaseTxt',
        type: 'texture',
        path: 'textures/hologram/hologramBaseTxt.jpg'
    },
    {
        name: 'hologramAlphaTxt',
        type: 'texture',
        path: 'textures/hologram/hologramAlphaTxt.jpg'
    },
    {
        name: 'kenpixel_ttf',
        type: 'ttf',
        path: 'font/kenpixel.ttf'
    },
    {
        name: 'star_wars_ttf',
        type: 'ttf',
        path: 'font/Starjedi.ttf'
    },
    {
        name: 'danger_ttf',
        type: 'ttf',
        path: 'font/elitedangerbold.ttf'
    }
]
